export default function Spinner ({ borderColor, height, width }) {
  return <div className={'loader ease-linear mx-auto rounded-full border-2 ' + borderColor + ' ' + height + ' ' + width } 
    ></div>
};

